import { jwtDecode, JwtPayload } from "jwt-decode";
import { Environment } from "shared/models";
import environments from "../../environments.json";

type CustomJwtPayload = JwtPayload & { realm_access: { roles: string[] } };

export function fetchAccessibleEnvironments(token: string): Environment[] {
  const { realm_access }: CustomJwtPayload = jwtDecode(token);
  const { roles } = realm_access;

  if (!roles) return [];

  const envs: { name: string; endpoint: string }[] = [];
  environments.environments.forEach((sp: Environment) =>
    envs.push({ name: sp.name, endpoint: sp.grpcEndpoint })
  );

  // find the names of the common endpoints between envs and uniqueList
  const namesOfAllowedEnvs: string[] = [];
  roles.forEach((u) => {
    envs.forEach((e) => {
      if (
        u &&
        u.includes(e.endpoint) &&
        namesOfAllowedEnvs.indexOf(e.name) === -1
      )
        namesOfAllowedEnvs.push(e.name);
    });
  });

  // find the environments that match the name of the common endpoints
  const accessibleEnvs = environments.environments.filter((e: Environment) => {
    if (namesOfAllowedEnvs.indexOf(e.name) !== -1) return e;
    return null;
  });

  return accessibleEnvs;
}

export function fetchUserRoles(token: string): string[] {
  const { realm_access }: CustomJwtPayload = jwtDecode(token);
  const { roles } = realm_access;

  if (!roles) return [];
  return roles;
}
